import { render, staticRenderFns } from "./NewsPopupV2.vue?vue&type=template&id=6474534e"
import script from "./NewsPopupV2.vue?vue&type=script&lang=js"
export * from "./NewsPopupV2.vue?vue&type=script&lang=js"
import style0 from "./NewsPopupV2.vue?vue&type=style&index=0&id=6474534e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports